import Translation from "src/translations/locales/translation";

import { useTranslation } from "react-i18next";
import { Alignment } from "src/components/alignment";
import { GetUrlParams } from "src/utils/GetUrlParams";
import { DyanmicOverview } from "src/composable/base-dynamic-overview";
import { Exercise, ExercisesRepository } from "src/components/exercises";

class InnerExercisesOverviewScreen extends DyanmicOverview<Exercise> {
  getTitle(): string | null {
    return this.state.item?.title ?? "";
  }

  getDescription(): string | null {
    return this.state.item?.shortDescription ?? "";
  }

  getThumbnail(): string | null {
    return this.state.item?.thumbnail ?? "";
  }

  getMoreInfoText(): string | null {
    return this.props.t(Translation.screens.overviews.moreInfoText);
  }

  getThumbnailAlignment(): Alignment | null {
    return this.state.item?.thumbnailAlignment ?? null;
  }
}

export default function ExercisesOverviewScreen() {
  const { t } = useTranslation();

  const id = GetUrlParams();

  return (
    <InnerExercisesOverviewScreen
      loadItem={async () => await new ExercisesRepository().get({})}
      id={id ?? null}
      t={t}
    />
  );
}
